import React, { useState, useEffect } from "react";
import { getNewsData, updateNewsData, deleteNewsData } from "../../controllers/NewsController";
import "./Partners.css";
import placeHolderImage from "../../assets/placeholder.jpg";
import { FaPlus, FaTrashAlt, FaRegSave } from "react-icons/fa";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";
import { IconButton } from "@mui/material";
import { convertToBase64 } from "../../utils/Utils";
import MenuOptions from "../Shared/MenuOptions/menuOptions";

const Position = {
  "Haut Gauche": "partnerImgBackgroundIconLeft",
  "Haut Droite": "partnerImgBackgroundIconRight",
  "Haut Centre": "partnerImgBackgroundIconCenter",
  "Bas Gauche": "partnerImgBackgroundIconLeftBottom",
  "Bas Droite": "partnerImgBackgroundIconRightBottom",
  "Bas Centre": "partnerImgBackgroundIconCenterBottom",
}

const LogoSize = {
  "Petit": "smallLogo",
  "Moyen": "mediumLogo",
  "Grand": "largeLogo",
}

function Partners() {
  const [isLoading, setIsLoading] = useState(true);
  const [sectionTitle, setSectionTitle] = useState("");
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [partners, setPartners] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  const logoOptions = [{
    title: "Position",
    subOptions: ["Haut Gauche", "Haut Droite", "Haut Centre", "Bas Gauche", "Bas Droite", "Bas Centre",]
  },
  { title: "Taille", subOptions: ["Petit", "Moyen", "Grand"] }];


  useEffect(() => {
    getNewsData("partenaires").then((data) => {
      if (data){
        setSectionTitle(data.title);
        if (data.partners.length > 0) {
          setPartners(data.partners);
        } else {
          setInitialPartner();
        }
      }
      setIsLoading(false);
    });
  }, []);

  const updatePartners = () => {
    const [isValid, errorMessage] = validateFormat();
    if (isValid) {
      const data = { title: sectionTitle, partners: partners };
      updateNewsData("partenaires", data).catch((error) => {
      }).finally(() => {
        setHasUnsavedChanges(false);
      });
    } else {
      setErrorMessage(errorMessage);
    }
  };

  const deletePartner = () => {
    deleteNewsData("partenaires", currentPage).then((data) => {
      const newPartners = [...partners];
      newPartners.splice(currentPage, 1);
      if (newPartners.length === 0) {
        setInitialPartner();
      } else {
        setPartners(newPartners);
      }
      setCurrentPage(0);
      setHasUnsavedChanges(false);
    })
  }

  const setInitialPartner = () => {
    const newPartner = { text: "Nouveau partenaire", sourceImage: "", source: placeHolderImage, link: "", position: "partnerImgBackgroundIconRight", logoSize: "smallLogo", resizeMode: null };
    setPartners([newPartner]);
  }


  const validateFormat = () => {
    const currentPartnerProject = partners[currentPage];
    if (currentPartnerProject.source === placeHolderImage) return [false, "Erreur: Une image est requise."];
    else if (currentPartnerProject.sourceImage === "") return [false, "Erreur: Un logo est requis."];
    return [true, undefined];
  }

  const updateLink = (link) => {
    const newPartners = [...partners];
    newPartners[currentPage].link = link;
    setPartners(newPartners);
    setHasUnsavedChanges(true);
  }

  const updateText = (text) => {
    const newPartners = [...partners];
    newPartners[currentPage].text = text;
    setPartners(newPartners);
    setHasUnsavedChanges(true);
  }

  const updateImage = (image) => {
    const newPartners = [...partners];
    convertToBase64(image).then((base64) => {
      newPartners[currentPage].source = base64;
      setPartners(newPartners);
      setErrorMessage("");
      setHasUnsavedChanges(true);
    })
  };

  const updateLogo = (image) => {
    const newPartners = [...partners];
    convertToBase64(image).then((base64) => {
      newPartners[currentPage].sourceImage = base64;
      setPartners(newPartners);
      setErrorMessage("");
      setHasUnsavedChanges(true);
    })
  };

  const addNewPartner = () => {
    const newPartner = { text: "Nouveau partenaire", sourceImage: "", source: placeHolderImage, link: "", position: "partnerImgBackgroundIconRight", logoSize: "smallLogo", resizeMode: null };
    setPartners([...partners, newPartner]);
    setCurrentPage(partners.length);
    setHasUnsavedChanges(true);
  }

  const handlePageChange = (index) => {
    setCurrentPage(index);
  };

  const selectLogoOption = (selectedOption, selectedSubOption) => {
    const newPartners = [...partners];
    if (selectedOption === "Position") {
      newPartners[currentPage].position = Position[selectedSubOption];
    }
    else if (selectedOption === "Taille") {
      newPartners[currentPage].logoSize = LogoSize[selectedSubOption];
    }
    setPartners(newPartners);
    setHasUnsavedChanges(true);
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="page-container">
      <h1 className="page-title">Partenaires</h1>
      <div className="card-container">
        <h2 className="card-title">{sectionTitle}</h2>
        <div className="card-text-input">
          <span className="text-label">Texte:</span>
          <input
            type="text"
            className="input-text"
            value={partners[currentPage].text || ""}
            onChange={(e) => updateText(e.target.value)}
          />
        </div>
        <div className="card-image flex-container" style={{ backgroundImage: `url(${partners[currentPage].source})`, backgroundSize: "cover", backgroundRepeat: "no-repeat" }}>
          {partners[currentPage].sourceImage !== "" && <img
            src={partners[currentPage].sourceImage}
            alt="Logo"
            className={`${partners[currentPage].position} ${partners[currentPage].logoSize}`}
          />}
        </div>
        <div className="card-buttons">
          <input
            type="file"
            accept="image/*"
            onChange={(e) => { updateImage(e.target.files[0]) }}
            style={{ display: "none" }}
            id="imageUpload"
          />
          <label htmlFor="imageUpload" className="card-button">
            Modifier l'image
          </label>
          <div className="button-with-options">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => { updateLogo(e.target.files[0]) }}
              style={{ display: "none" }}
              id="logoUpload"
            />
            <label htmlFor="logoUpload" className="card-button">
              Modifier le logo
            </label>
            <MenuOptions options={logoOptions} selectOption={selectLogoOption} />
          </div>
        </div>
        <div className="card-text-input">
          <span className="text-label">URL:</span>
          <input
            type="text"
            className="input-text"
            value={partners[currentPage].link}
            onChange={(event) => { updateLink(event.target.value) }}
          />
        </div>
        {errorMessage.length !== 0 && <p className="error-message">{errorMessage}</p>}
        <div className="card-footer">
          <div className="footer-options">
            <button className="card-button footer-option" disabled={hasUnsavedChanges} onClick={() => addNewPartner()}>
              <FaPlus />
            </button>
            <button className="card-button footer-option" disabled={!hasUnsavedChanges} onClick={() => updatePartners()} >
              <FaRegSave />
            </button>
            <button className="card-button footer-option" onClick={() => deletePartner()}>
              <FaTrashAlt />
            </button>
          </div>
          <div className="pagination-container">
            <IconButton disabled={currentPage === 0} onClick={() => handlePageChange(currentPage - 1)}>
              <MdNavigateBefore className="navigation-arrow" />
            </IconButton>
            {partners.map((_, index) => (
              <button
                key={index}
                disabled={hasUnsavedChanges}
                onClick={() => handlePageChange(index)}
                className={`pagination-circle ${currentPage === index ? "active" : ""
                  }`}
              />
            ))}
            <IconButton disabled={currentPage === partners.length - 1} onClick={() => handlePageChange(currentPage + 1)}>
              <MdNavigateNext className="navigation-arrow" />
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Partners;
